// extracted by mini-css-extract-plugin
export var row = "valueRow-module--row--xN6Er";
export var card = "valueRow-module--card--RqqAk";
export var icon = "valueRow-module--icon--qlW40";